import { render, staticRenderFns } from "./drag-kanban.vue?vue&type=template&id=f53f101e&"
import script from "./drag-kanban.vue?vue&type=script&lang=js&"
export * from "./drag-kanban.vue?vue&type=script&lang=js&"
import style0 from "./drag-kanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f53f101e')) {
      api.createRecord('f53f101e', component.options)
    } else {
      api.reload('f53f101e', component.options)
    }
    module.hot.accept("./drag-kanban.vue?vue&type=template&id=f53f101e&", function () {
      api.rerender('f53f101e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/drag-kanban.vue"
export default component.exports